import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from "vue"
import Dropzone from "@/components/widgets/input/Dropzone.vue"
import CompanyInfoSection from "./CompanyInfoSection.vue"
import {
  UploadFileInput,
  UpdateCompanyProfileMutation,
  UpdateCompanyProfileMutationMutationVariables,
  UpdateCompanyProfileMutationMutation,
  MissionRequestBusinessIndustry,
} from "@/gql"
import { useMutation } from "@/hooks/useMutation"
import { useNotification } from "@/hooks/useNotification"
import CountrySelect from "@/components/widgets/input/CountrySelect.vue"
import IndustriesSelect from "@/components/widgets/input/IndustriesSelect.vue"

export type CompanyProfile = {
  clientId: string | null
  name: string
  address: string
  description: string
  countryId: number | null
  tagline?: string
  companyLogo?: UploadFileInput | null
  industry: MissionRequestBusinessIndustry | null
  website: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CompanyDetailsInfoForm',
  props: {
    company: null,
    onUpdated: null
  },
  emits: ["cancel", "complete"],
  setup(__props: any, { emit }) {

const props = __props as {
  company: CompanyProfile
  onUpdated?: () => void
}


const { mutate } = useMutation()
const { addSuccess } = useNotification()



const showConfirmDialog = ref(false)

const form = ref<CompanyProfile>({
  clientId: null,
  name: "",
  address: "",
  description: "",
  countryId: null,
  tagline: "",
  companyLogo: null,
  industry: null,
  website: "",
})

watch(
  () => props.company,
  (company) => {
    if (!company) return

    form.value = {
      ...form.value,
      name: company.name,
      clientId: company.clientId,
      address: company.address,
      description: company.description,
      countryId: company.countryId,
      industry: company.industry,
      website: company.website,
    }
  },
  {
    immediate: true,
    deep: true,
  }
)

const logoPreviewUrl = ref<string | null>(null)
const isSubmitting = ref(false)

const onLogoChange = (file: File[]) => {
  if (file.length) {
    const url = URL.createObjectURL(file[0])
    logoPreviewUrl.value = url
  }
}

const onUpdateDetails = async () => {
  isSubmitting.value = true

  await mutate<UpdateCompanyProfileMutationMutation, UpdateCompanyProfileMutationMutationVariables>(
    {
      mutation: UpdateCompanyProfileMutation,
      variables: {
        name: form.value.name,
        address: form.value.address,
        description: form.value.description,
        companyLogo: form.value.companyLogo,
        clientId: props.company.clientId as string,
        countryId: form.value.countryId?.toString(),
        industry: form.value.industry,
        website: form.value.website,
      },
      handlePayloadErrors: true,
      onSuccess: () => {
        addSuccess("Profile updated successfully!")
        showConfirmDialog.value = false
        emit("complete")
        props.onUpdated?.()
      },
    }
  )

  isSubmitting.value = false
}

return { __sfc: true,emit, mutate, addSuccess, props, showConfirmDialog, form, logoPreviewUrl, isSubmitting, onLogoChange, onUpdateDetails, Dropzone, CompanyInfoSection, CountrySelect, IndustriesSelect }
}

})